<template>
  <base-view :title="title">
    <b-row>
      <b-col cols="12">
        <slot name="filters"></slot>
      </b-col>
      <b-col cols="12" class="mt-2">
        <slot name="actions">
          <b-button
            variant="success"
            @click="$emit('search')"
            :disabled="loading"
          >
            <i class="fas fa-search mr-2"></i>
            Pesquisar
          </b-button>
    <b-button
        class="btn-warning ml-3 text-white"
        href="https://api.construp.com.br/assets/Doc_webhook.pdf"
        target="_blank"
        download
    >
        Baixar Documentação Webhook
    </b-button>
        </slot>
      </b-col>
      <b-col
        cols="12"
        class="mt-5 mb-2 d-flex align-items-center justify-content-between"
      >
        <slot name="table-header">
          <h3 class="title font-weight-bold" v-if="showTableHeader">
            <slot name="table-header-title" :total="pagination.total" v-if="pagination.total">
              {{ pagination.total || 0 }} registros encontrados
            </slot>

            <slot name="table-header-title" :total="pagination.total" v-else>
              {{countProducts}} registros encontrados
            </slot>
          </h3>
        </slot>
        <slot name="table-header-left">
        </slot>
      </b-col>
      <b-col cols="12">
        <slot name="table">
          <b-table
            v-if="useTable"
            striped
            hover
            show-empty
            empty-text="Sem registros encontrados"
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
          />
        </slot>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <slot name="pagination">
          <b-pagination
            v-if="usePagination"
            v-model="pagination.currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.itemsPerPage"
            :disabled="loading"
          ></b-pagination>
        </slot>
      </b-col>
      <slot />
    </b-row>
  </base-view>
</template>

<script>
import BaseView from './BaseView.vue';

export default {
  name: 'BaseViewTable',
  components: {
    BaseView,
  },
  props: {
    title: {
      type: String,
      default: 'Sem nome',
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    useTable: {
      type: Boolean,
      default: true,
    },
    showTableHeader: {
      type: Boolean,
      default: true,
    },
    usePagination: {
      type: Boolean,
      default: true,
    },
    table: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },

    countProducts: {
      type: Number,
    }
  },
};
</script>